import React from 'react'; // Importa React para poder usar JSX
import { ultimasNoticias } from '../../json/ultimasNoticias'; // Importa los datos de últimas noticias desde un archivo JSON
import { useState, useEffect } from 'react'; // Importa hooks de React para gestionar el estado y efectos
import './ultimasnoticias.css'; // Importa estilos CSS específicos para este componente

const UltimasNoticias = () => {
  // Estado para almacenar las noticias obtenidas de la API
  const [noticias, setNoticias] = useState([]);

  // Efecto para realizar una llamada a la API cuando se monta el componente
  useEffect(() => {
    fetch('https://comunicacion-a.hidalgo.gob.mx/traer/notas', {
      method: 'POST', // Método de la petición
      headers: {
        'Content-Type': 'application/json' // Especifica el tipo de contenido de la petición
      }
    })
      .then(response => response.json()) // Convierte la respuesta en JSON
      .then(data => {
        console.log(data.success.notas); // Muestra las notas en la consola
        if (data.success.notas.length > 0) { // Verifica si hay notas en la respuesta
          setNoticias(data.success.notas); // Actualiza el estado con las notas obtenidas
        }
      })
      .catch(error => console.error(error)); // Manejo de errores en caso de fallo en la petición
  }, []); // El efecto se ejecuta una sola vez al montar el componente

  return (
    <div id='ultimas_noticias'> {/* Contenedor principal de Últimas Noticias */}
      <div className='row'> {/* Fila para estructura de Bootstrap */}
        <div className='col-12'> {/* Columna que ocupa todo el ancho */}
          <div className='notice_section'> {/* Sección que contiene las noticias */}
            <div className='notice_title'> {/* Título de la sección */}
              <h3 className='title'>ÚLTIMAS NOTICIAS</h3> {/* Título visible */}
              <hr className='hr-gob'/> {/* Línea horizontal de separación */}
            </div>
            <div className='notice_content'> {/* Contenido de la sección de noticias */}
              <div className='col-sm-8 col-12'> {/* Columna más ancha para el carrusel */}
                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel"> {/* Carrusel de Bootstrap */}
                  <div className="carousel-inner"> {/* Contenedor de las imágenes del carrusel */}
                    {
                      // Mapea los datos de ultimasNoticias para generar las imágenes del carrusel
                      ultimasNoticias.map((item, index) => (
                        <div key={index} className={index >= 1 ? "carousel-item" : "carousel-item active"}> {/* Activa el primer item */}
                          <a href={item.url} target="_blank" rel="noopener noreferrer"> {/* Enlace a la noticia */}
                            <div className="img-carousel d-block w-100" style={{ backgroundImage: `url("${item.imagen}")` }} alt="First slide">
                              {/* Fondo de la imagen del carrusel */}
                              <div className='title_img_carousel'>
                                <h6>{item.titulo}</h6> {/* Título de la noticia */}
                                <p>{item.fecha}</p> {/* Fecha de la noticia */}
                              </div>
                            </div>
                          </a>
                        </div>
                      ))
                    }
                  </div>
                  {/* Botones de control del carrusel */}
                  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span> {/* Icono de anterior */}
                    <span className="visually-hidden">Previous</span> {/* Texto oculto para accesibilidad */}
                  </button>
                  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span> {/* Icono de siguiente */}
                    <span className="visually-hidden">Next</span> {/* Texto oculto para accesibilidad */}
                  </button>
                </div>
              </div>
              

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UltimasNoticias; // Exporta el componente UltimasNoticias
